module.exports = __webpack_public_path__ + "img/1.0d8575c9.webp";